import { COFAndIndividualQuestionnarieFormValues } from '../../../individual/types';
import { ApplicationScheme } from '../../../common/types';

const getCofandIndividualQuestionnarieBody = ({
  questionnarieValues,
  scheme,
}: {
  questionnarieValues: COFAndIndividualQuestionnarieFormValues;
  scheme: ApplicationScheme;
}) => {
  const questionnarieBody: COFAndIndividualQuestionnarieFormValues = {};

  if (
    scheme?.nationalInsuranceNumberOfDirectorsActive &&
    questionnarieValues.nationalInsuranceNumberOfDirectors
  ) {
    questionnarieBody.nationalInsuranceNumberOfDirectors =
      questionnarieValues.nationalInsuranceNumberOfDirectors;
  }

  if (
    scheme?.lastThreeYearsAddressHistoryActive &&
    questionnarieValues.lastThreeYearsAddressHistory
  ) {
    questionnarieBody.lastThreeYearsAddressHistory =
      questionnarieValues.lastThreeYearsAddressHistory;
  }

  if (scheme?.criminalOfAnyActive) {
    if (questionnarieValues.criminalConvictedOfAny) {
      questionnarieBody.criminalConvictedOfAny = Boolean(
        questionnarieValues.criminalConvictedOfAny === 'yes',
      );
    }

    if (questionnarieValues.criminalReceivedACautionForAny) {
      questionnarieBody.criminalReceivedACautionForAny = Boolean(
        questionnarieValues.criminalReceivedACautionForAny === 'yes',
      );
    }

    if (questionnarieValues.criminalArrestedOrChargedWithOrBeenInvolved) {
      questionnarieBody.criminalArrestedOrChargedWithOrBeenInvolved = Boolean(
        questionnarieValues.criminalArrestedOrChargedWithOrBeenInvolved ===
        'yes',
      );
    }

    if (questionnarieValues.criminalSubjectToAnyCurrentCriminalInvestigation) {
      questionnarieBody.criminalSubjectToAnyCurrentCriminalInvestigation =
        Boolean(
          questionnarieValues.criminalSubjectToAnyCurrentCriminalInvestigation ===
          'yes',
        );
    }

    if (
      questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenConvicted
    ) {
      questionnarieBody.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenConvicted =
        Boolean(
          questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenConvicted ===
          'yes',
        );
    }

    if (
      questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenOrdered
    ) {
      questionnarieBody.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenOrdered =
        Boolean(
          questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenOrdered ===
          'yes',
        );
    }

    if (
      questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenInvolved
    ) {
      questionnarieBody.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenInvolved =
        Boolean(
          questionnarieValues.criminalFirmWhereYouHeldAPositionOfInfluenceEverBeenInvolved ===
          'yes',
        );
    }
  }

  if (scheme?.civilActive) {
    if (questionnarieValues.civilFoundLiableForFraud) {
      questionnarieBody.civilFoundLiableForFraud = Boolean(
        questionnarieValues.civilFoundLiableForFraud === 'yes',
      );
    }

    if (questionnarieValues.civilSubjectToAJudgmentDebt) {
      questionnarieBody.civilSubjectToAJudgmentDebt = Boolean(
        questionnarieValues.civilSubjectToAJudgmentDebt === 'yes',
      );
    }

    if (questionnarieValues.civilInvolvedInAnyCivilProceedings) {
      questionnarieBody.civilInvolvedInAnyCivilProceedings = Boolean(
        questionnarieValues.civilInvolvedInAnyCivilProceedings === 'yes',
      );
    }

    if (questionnarieValues.civilYouHeldAPositionOfInfluence) {
      questionnarieBody.civilYouHeldAPositionOfInfluence = Boolean(
        questionnarieValues.civilYouHeldAPositionOfInfluence === 'yes',
      );
    }

    if (questionnarieValues.civilFiledForBankruptcy) {
      questionnarieBody.civilFiledForBankruptcy = Boolean(
        questionnarieValues.civilFiledForBankruptcy === 'yes',
      );
    }

    if (questionnarieValues.civilSubjectToABankruptcy) {
      questionnarieBody.civilSubjectToABankruptcy = Boolean(
        questionnarieValues.civilSubjectToABankruptcy === 'yes',
      );
    }
  }

  if (scheme?.businessAndEmploymentActive) {
    if (questionnarieValues.businessAndEmploymentDismissedOrAskedTo) {
      questionnarieBody.businessAndEmploymentDismissedOrAskedTo = Boolean(
        questionnarieValues.businessAndEmploymentDismissedOrAskedTo === 'yes',
      );
    }

    if (
      questionnarieValues.businessAndEmploymentDisqualifiedFromActingAsADirector
    ) {
      questionnarieBody.businessAndEmploymentDisqualifiedFromActingAsADirector =
        Boolean(
          questionnarieValues.businessAndEmploymentDisqualifiedFromActingAsADirector ===
          'yes',
        );
    }

    if (
      questionnarieValues.businessAndEmploymentTheSubjectOfAnyDisciplinaryProceedings
    ) {
      questionnarieBody.businessAndEmploymentTheSubjectOfAnyDisciplinaryProceedings =
        Boolean(
          questionnarieValues.businessAndEmploymentTheSubjectOfAnyDisciplinaryProceedings ===
          'yes',
        );
    }
  }

  if (scheme?.regulatoryActive) {
    if (
      questionnarieValues.regulatoryAnAuthorizationFromARegulatoryBodyRefused
    ) {
      questionnarieBody.regulatoryAnAuthorizationFromARegulatoryBodyRefused =
        Boolean(
          questionnarieValues.regulatoryAnAuthorizationFromARegulatoryBodyRefused ===
          'yes',
        );
    }

    if (questionnarieValues.regulatoryCensured) {
      questionnarieBody.regulatoryCensured = Boolean(
        questionnarieValues.regulatoryCensured === 'yes',
      );
    }

    if (
      questionnarieValues.regulatoryInvolvedInAnyActivitiesRequiringAuthorization
    ) {
      questionnarieBody.regulatoryInvolvedInAnyActivitiesRequiringAuthorization =
        Boolean(
          questionnarieValues.regulatoryInvolvedInAnyActivitiesRequiringAuthorization ===
          'yes',
        );
    }

    if (questionnarieValues.regulatorySubjectToAnyDisqualification) {
      questionnarieBody.regulatorySubjectToAnyDisqualification = Boolean(
        questionnarieValues.regulatorySubjectToAnyDisqualification === 'yes',
      );
    }
  }

  if (
    scheme?.id === 'ed560559-8354-4634-b6dd-eb341dfb551a' ||
    scheme?.id === 'a87db4b4-3c78-4564-bba1-c16a19553159'
  ) {
    if (questionnarieValues?.otherNationalitiesIds?.length) {
      questionnarieBody.otherNationalitiesIds =
        questionnarieValues?.otherNationalitiesIds;
    } else {
      questionnarieBody.otherNationalitiesIds = [];
    }

    if (questionnarieValues?.maritalStatus) {
      questionnarieBody.maritalStatus = questionnarieValues?.maritalStatus;
    }

    if (questionnarieValues?.spouseFullName) {
      questionnarieBody.spouseFullName = questionnarieValues?.spouseFullName;
    }

    if (questionnarieValues?.natureOfBusinessActivity) {
      questionnarieBody.natureOfBusinessActivity =
        questionnarieValues?.natureOfBusinessActivity;
    }

    if (questionnarieValues?.nameOfCompany) {
      questionnarieBody.nameOfCompany = questionnarieValues?.nameOfCompany;
    }

    if (questionnarieValues?.ownership?.toString()) {
      questionnarieBody.ownership = Number(questionnarieValues?.ownership);
    }

    if (questionnarieValues.belongsToGroup) {
      questionnarieBody.belongsToGroup = Boolean(
        questionnarieValues.belongsToGroup === 'yes',
      );
    }

    if (questionnarieValues?.parentCompanyName) {
      questionnarieBody.parentCompanyName =
        questionnarieValues?.parentCompanyName;
    }

    if (questionnarieValues?.parentCompanyCountryId) {
      questionnarieBody.parentCompanyCountryId =
        questionnarieValues?.parentCompanyCountryId;
    }

    if (questionnarieValues?.subsidiariesInfo) {
      questionnarieBody.subsidiariesInfo =
        questionnarieValues?.subsidiariesInfo;
    }

    if (questionnarieValues?.mainActivities) {
      questionnarieBody.mainActivities = questionnarieValues?.mainActivities;
    }

    if (questionnarieValues?.groupWealthSourceIds?.length) {
      questionnarieBody.groupWealthSourceIds =
        questionnarieValues?.groupWealthSourceIds;
    }

    if (questionnarieValues?.groupWealthSourceOther) {
      questionnarieBody.groupWealthSourceOther =
        questionnarieValues?.groupWealthSourceOther;
    }

    if (questionnarieValues?.estimatedTotalWealthEuro?.toString()) {
      questionnarieBody.estimatedTotalWealthEuro = Number(
        questionnarieValues?.estimatedTotalWealthEuro,
      );
    }

    if (questionnarieValues.requiresSourcesOfIncomes) {
      questionnarieBody.requiresSourcesOfIncomes = Boolean(
        questionnarieValues.requiresSourcesOfIncomes === 'yes',
      );
    }

    if (questionnarieValues?.sourcesOfIncomes?.length) {
      questionnarieBody.sourcesOfIncomes = questionnarieValues?.sourcesOfIncomes
        ?.filter((item) => item.sourceId)
        ?.map((item) => ({
          sourceId: item.sourceId,
          value: Number(item.value),
        }));
    }

    if (questionnarieValues?.sourcesOfIncomesOther) {
      questionnarieBody.sourcesOfIncomesOther =
        questionnarieValues?.sourcesOfIncomesOther;
    }

    if (questionnarieValues?.sourcesOfIncomesBorrowedOther) {
      questionnarieBody.sourcesOfIncomesBorrowedOther =
        questionnarieValues?.sourcesOfIncomesBorrowedOther;
    }

    if (questionnarieValues.requiresSourceAndSizeOfWealth) {
      questionnarieBody.requiresSourceAndSizeOfWealth = Boolean(
        questionnarieValues.requiresSourceAndSizeOfWealth === 'yes',
      );
    }

    if (questionnarieValues?.sourcesAndSizesOfWealth?.length) {
      questionnarieBody.sourcesAndSizesOfWealth =
        questionnarieValues?.sourcesAndSizesOfWealth
          ?.filter((item) => item.sourceId)
          ?.map((item) => ({
            sourceId: item.sourceId,
            value: Number(item.value),
          }));
    }

    if (questionnarieValues?.sourcesAndSizesOfWealthOther) {
      questionnarieBody.sourcesAndSizesOfWealthOther =
        questionnarieValues?.sourcesAndSizesOfWealthOther;
    }

    if (questionnarieValues?.sourcesAndSizesOfWealthBorrowedOther) {
      questionnarieBody.sourcesAndSizesOfWealthBorrowedOther =
        questionnarieValues?.sourcesAndSizesOfWealthBorrowedOther;
    }

    if (questionnarieValues.requiresNetWorth) {
      questionnarieBody.requiresNetWorth = Boolean(
        questionnarieValues.requiresNetWorth === 'yes',
      );
    }

    if (questionnarieValues?.netWorthAmount?.toString()) {
      questionnarieBody.netWorthAmount = Number(
        questionnarieValues?.netWorthAmount,
      );
    }

    if (questionnarieValues?.sourcesOfFundsIds?.length) {
      questionnarieBody.sourcesOfFundsIds =
        questionnarieValues?.sourcesOfFundsIds;
    }

    if (questionnarieValues?.sourcesOfFundsOther) {
      questionnarieBody.sourcesOfFundsOther =
        questionnarieValues?.sourcesOfFundsOther;
    }

    if (questionnarieValues?.sourcesOfFundsLoanCreditInstitution) {
      questionnarieBody.sourcesOfFundsLoanCreditInstitution =
        questionnarieValues?.sourcesOfFundsLoanCreditInstitution;
    }

    if (questionnarieValues?.sourcesOfFundsLoanBusinessPartner) {
      questionnarieBody.sourcesOfFundsLoanBusinessPartner =
        questionnarieValues?.sourcesOfFundsLoanBusinessPartner;
    }

    if (questionnarieValues.hasAccountsInOtherFinancialInstitutions) {
      questionnarieBody.hasAccountsInOtherFinancialInstitutions = Boolean(
        questionnarieValues.hasAccountsInOtherFinancialInstitutions === 'yes',
      );
    }

    if (questionnarieValues?.otherFinancialInstitutions) {
      questionnarieBody.otherFinancialInstitutions =
        questionnarieValues?.otherFinancialInstitutions;
    }

    if (questionnarieValues?.groupWealthSourceOther) {
      questionnarieBody.groupWealthSourceOther =
        questionnarieValues?.groupWealthSourceOther;
    }

    if (questionnarieValues?.secondPassportExpiryDate) {
      questionnarieBody.secondPassportExpiryDate =
        questionnarieValues?.secondPassportExpiryDate;
    }

    if (questionnarieValues?.secondPassportIssueCountryId) {
      questionnarieBody.secondPassportIssueCountryId =
        questionnarieValues?.secondPassportIssueCountryId;
    }

    if (questionnarieValues?.secondPassportIssueDate) {
      questionnarieBody.secondPassportIssueDate =
        questionnarieValues?.secondPassportIssueDate;
    }

    if (questionnarieValues?.secondPassportNumber) {
      questionnarieBody.secondPassportNumber =
        questionnarieValues?.secondPassportNumber;
    }

    if (questionnarieValues?.isPepOrAssociate) {
      questionnarieBody.isPepOrAssociate =
        questionnarieValues?.isPepOrAssociate;
    }

    if (questionnarieValues.isPepOrAssociate) {
      questionnarieBody.isPepOrAssociate = Boolean(
        questionnarieValues.isPepOrAssociate === 'yes',
      );
    }

    if (questionnarieValues.hasAffiliatedCompanies) {
      questionnarieBody.hasAffiliatedCompanies = Boolean(
        questionnarieValues.hasAffiliatedCompanies === 'yes',
      );
    }

    if (questionnarieValues.nameOfPep) {
      questionnarieBody.nameOfPep = questionnarieValues.nameOfPep;
    }

    if (questionnarieValues.relToPep) {
      questionnarieBody.relToPep = questionnarieValues.relToPep;
    }

    if (questionnarieValues.orgEmployerAndPosition) {
      questionnarieBody.orgEmployerAndPosition =
        questionnarieValues.orgEmployerAndPosition;
    }

    if (questionnarieValues.positionHeldCountryId) {
      questionnarieBody.positionHeldCountryId =
        questionnarieValues.positionHeldCountryId;
    }

    if (questionnarieValues.politicalFunctionPeriodFrom) {
      questionnarieBody.politicalFunctionPeriodFrom =
        questionnarieValues.politicalFunctionPeriodFrom;
    }

    if (questionnarieValues.politicalFunctionPeriodTo) {
      questionnarieBody.politicalFunctionPeriodTo =
        questionnarieValues.politicalFunctionPeriodTo;
    }

    if (questionnarieValues.abilityMoveGovernmentFunds) {
      questionnarieBody.abilityMoveGovernmentFunds = Boolean(
        questionnarieValues.abilityMoveGovernmentFunds === 'yes',
      );
    }

    if (questionnarieValues.abilityMoveGovernmentFundsDetails) {
      questionnarieBody.abilityMoveGovernmentFundsDetails =
        questionnarieValues.abilityMoveGovernmentFundsDetails;
    }

    if (questionnarieValues.isUSCitizen) {
      questionnarieBody.isUSCitizen = Boolean(
        questionnarieValues.isUSCitizen === 'yes',
      );
    }

    if (questionnarieValues?.homePhoneNumber) {
      questionnarieBody.homePhoneNumber = questionnarieValues?.homePhoneNumber;
    }

    if (questionnarieValues?.emails?.length) {
      questionnarieBody.emails = questionnarieValues?.emails;
    }
  }

  return questionnarieBody;
};

export default getCofandIndividualQuestionnarieBody;
